(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jjt-on-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){var root=document.querySelector('[data-jjt-plp]');if(!root)return;var drawer=root.querySelector('[data-jjt-filter]');var sticky=root.querySelector('[data-jjt-plp-sticky]');var lastY=window.scrollY;function toggle(open){drawer.classList.toggle('is-open',open);drawer.setAttribute('aria-hidden',open?'false':'true');document.body.style.overflow=open?'hidden':''}root.querySelectorAll('[data-jjt-filter-open]').forEach(function(b){b.onclick=function(){toggle(true)}});root.querySelectorAll('[data-jjt-filter-close]').forEach(function(b){b.onclick=function(){toggle(false)}});function initializeFavorites(scope){scope.querySelectorAll('[data-jjt-favorite]').forEach(function(b){var key='jjt-favorite-'+b.dataset.jjtFavorite;try{b.classList.toggle('is-active',localStorage.getItem(key)==='1')}catch(e){}b.onclick=function(){var active=b.classList.toggle('is-active');try{localStorage.setItem(key,active?'1':'0')}catch(e){}}})}initializeFavorites(root);root.addEventListener('jjt:products-added',function(event){event.detail.cards.forEach(initializeFavorites)});function syncSticky(){if(!sticky)return;var y=window.scrollY;var deep=window.innerWidth<=760&&root.getBoundingClientRect().top<-220;var show=deep&&y<lastY;sticky.classList.toggle('is-visible',show);sticky.setAttribute('aria-hidden',show?'false':'true');lastY=y}window.addEventListener('scroll',syncSticky,{passive:true});window.addEventListener('resize',syncSticky);syncSticky();document.addEventListener('keydown',function(e){if(e.key==='Escape')toggle(false)})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jjt-wholesale-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('_form_14_');
    if (!form || form.dataset.jjtEnhanced === 'true') return;
    form.dataset.jjtEnhanced = 'true';

    var content = form.querySelector('._form-content');
    var sectionData = [
      { selector: '._x18371561', number: '01', title: 'Your details' },
      { selector: '._field8', number: '02', title: 'Business information' },
      { selector: '._field16', number: '03', title: 'Program interests' }
    ];

    sectionData.forEach(function (item) {
      var field = form.querySelector(item.selector);
      if (!field || !content) return;
      var heading = document.createElement('div');
      heading.className = 'jjt-wholesale__form-section';
      heading.innerHTML = '<span>' + item.number + '</span><h3>' + item.title + '</h3>';
      content.insertBefore(heading, field);
    });

    var email = form.querySelector('#email');
    var phone = form.querySelector('[name="field[15]"]');
    var website = form.querySelector('[name="field[22]"]');
    var submit = form.querySelector('#_form_14_submit');
    var thankYou = form.querySelector('._form-thank-you');

    if (email) {
      email.type = 'email';
      email.autocomplete = 'email';
    }
    if (phone) {
      phone.type = 'tel';
      phone.autocomplete = 'tel';
      phone.inputMode = 'tel';
    }
    if (website) {
      website.type = 'url';
      website.autocomplete = 'url';
      website.inputMode = 'url';
    }
    if (submit) submit.textContent = 'Send application';
    if (thankYou) {
      thankYou.setAttribute('role', 'status');
      thankYou.setAttribute('aria-live', 'polite');
    }

    var autocompleteMap = {
      fullname: 'name',
      'field[8]': 'organization',
      'field[9]': 'address-line1',
      'field[10]': 'address-line2',
      'field[11]': 'address-level2',
      'field[12]': 'address-level1',
      'field[13]': 'postal-code',
      'field[14]': 'country-name'
    };

    Object.keys(autocompleteMap).forEach(function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      if (input) input.autocomplete = autocompleteMap[name];
    });
  });

  } catch(e) { console.error(e); }
})();
})();
